<template>
  <button class="button-toggle"
          :class="class_active"
          :title="title">
    <svg
      class="button-toggle__icon"
      :width="size"
      :height="size"
      @click="onClick"
    >
      <use :xlink:href="iconHref" />
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    iconHref: {
      type: String,
      required: true
    },

    active: {
      type: Boolean,
      required: true
    },

    size: {
      type: Number,
      default: 20
    },

    titleActive: {
      type: String,
      default: null
    },

    titleInactive: {
      type: String,
      default: null
    },

    isFavorite: {
      type: String,
      default: "false"
    }
  },

  computed: {
    title() {
      return this.active ? this.titleActive : this.titleInactive;
    },

    class_active() {
        return this.active ? (this.isFavorite === "true" ? "_active_no_highlight" : "_active") : "";
    }
    
  },

  methods: {
    onClick() {
      this.$emit('click', this.active);
    }
  }
};
</script>
